import styled from 'styled-components';

export const StyledNav = styled.nav`
    position: relative;
    height: 55px;
    flex: 1 1 auto;

    .menu-conteneur {
        height: 100%;
        justify-content: space-between;

        & > a {
            position: relative;
            display: flex;
            align-items: center;
            text-decoration: none;
            text-transform: ${props => props.theme.navItemTransform};
            font-weight: ${props => props.theme.navItemFontWeight};
            overflow: hidden;
            color: ${props => props.theme.navItemText};

            &:after {
                content: '';
                display: block;
                position: absolute;
                bottom: 0;
                height: 2px;
                width: 60px;
                transform: translateY(5px);
                transition: transform 0.2s cubic-bezier(0.16, 0.49, 0.42, 0.99);
            }

            &.actif {
                color: ${props => props.theme.navItemActiveText};
                font-weight: ${props => props.theme.navItemActiveTextWeight};

                &:after {
                    background: ${props => props.theme.navItemActiveBorder};
                    transform: translateY(0);
                }
            }
        }
    }

    .sous-menu-rubriques {
        position: absolute;
        z-index: 5;
        top: 100%;
        left: 0;
        right: 0;
        margin: auto;
        background: ${props => props.theme.subNavBg};
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.2s cubic-bezier(0.16, 0.49, 0.42, 0.99);

        a {
            margin: 14px 0;
            text-decoration: none;
            font-weight: ${props => props.theme.subNavTextWeight};
            width: 25%;
            color: ${props => props.theme.subNavText};

            &:hover {
                font-weight: ${props => props.theme.subNavFontWeight};
            }
        }

        span:first-child {
            width: 25px;
        }

        span {
            float: left;
        }

        svg {
            max-height: 17.5px;

            path {
                fill: ${props => props.theme.subNavSvgColor};
            }
        }

        > .conteneur {
            padding: 30px 0;
            -webkit-flex-flow: column wrap;
            flex-flow: column wrap;
            -webkit-align-content: stretch;
            align-content: stretch;
            height: 270px;
        }
    }

    /*** seulement desktop ***/
    @media screen and (min-width: ${props => props.theme.large} + 1px) {
        /* hover in reactJs */
        & .sous-menu-rubriques {
            &.open {
                max-height: 270px;
            }
        }
        & .menu-conteneur > a:not(.actif):hover:after {
            transform: translateY(0);
            background: ${props => props.theme.navItemBorderHover};
        }
    }

    /*** Style mobile et tablette ***/
    @media screen and (max-width: ${props => props.theme.large}) {
        /*** sous menu tablette mobile ***/
        & .sous-menu-rubriques {
            &.open {
                max-height: 270px;
            }
        }
        & .sous-menu-rubriques > .conteneur {
            padding: 30px 20px;
        }
        & .sous-menu-rubriques a {
            margin: 10px 0;
            width: auto;
        }
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        /*** menu ***/
        &.open {
            transform: translateX(0);
        }

        & .menu-conteneur {
            flex-direction: column;
            justify-content: initial;
            flex-wrap: nowrap;
            background: ${props => props.theme.navBackgroundColor};
        }
        & .menu-conteneur > a {
            flex: 0 0 auto;
            height: 51px;
            padding: 0 20px;
            border-top: 1px solid ${props => props.theme.navMobileBorderColor};
        }
        & .menu-conteneur > a:after {
            display: none;
        }
        & a.actif {
            border-color: ${props => props.theme.navMobileBorderColor};
        }
        /*** sous menu rubriques ***/
        & .sous-menu-rubriques {
            position: relative;
            top: initial;
            margin: 0;
            background: ${props => props.theme.subNavMobileBackgroundColor};
            box-shadow: none;
            overflow-y: scroll;
            overflow-x: hidden;
        }
        & .sous-menu-rubriques.open {
            max-height: 100%;
        }
        & .sous-menu-rubriques > div.conteneur {
            padding: 0;
            -webkit-flex-flow: column nowrap;
            flex-flow: column nowrap;
            -webkit-align-content: center;
            align-content: center;
            height: auto;
        }
        & .sous-menu-rubriques a {
            display: block;
            padding: 10px 20px;
            margin: 0;
            width: 100%;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/header/minimal/MinimalNavComponentStyle.js